import { CalculatorId } from '../../../lib/calculators/calculator-config';
import type { CalculatorDescription } from '../../../lib/calculators/calculator-description';

export const confidenceIntervalDescription: CalculatorDescription = {
  id: CalculatorId.CONFIDENCE_INTERVAL,
  title: 'Confidence Interval Calculator',
  metaTitle: 'Online Confidence Interval Calculator - Statistical Estimation Tool',
  description: 'Calculate confidence intervals for population means. Estimate population parameters with specified confidence levels using sample data.',
  metaDescription: 'Calculate confidence intervals online. Estimate population means with our free calculator. Analyze sample data with specified confidence levels.',
  howTo: {
    title: 'How to Use the Confidence Interval Calculator',
    steps: [
      'Enter your sample data',
      'Select a confidence level (90%, 95%, or 99%)',
      'View the calculated confidence interval',
      'Interpret the results with provided explanations',
      'Visualize the sampling distribution'
    ],
    graphic: {
      description: 'A data input form with confidence level selection and results showing interval bounds and visualization'
    }
  },
  examples: [
    {
      title: 'Quality Control',
      description: 'Estimating true average product measurements',
      dataDescription: 'Sample measurements from production line',
      insights: [
        'Estimates population mean',
        'Shows estimation precision',
        'Guides sample size needs',
        'Supports quality decisions'
      ]
    },
    {
      title: 'Medical Research',
      description: 'Estimating treatment effectiveness',
      dataDescription: 'Patient outcome measurements',
      insights: [
        'Estimates true effect',
        'Shows result reliability',
        'Guides study power',
        'Supports clinical decisions'
      ]
    }
  ],
  relatedCalculators: [
    CalculatorId.MEAN,
    CalculatorId.STANDARD_DEVIATION,
    CalculatorId.NORMAL_DISTRIBUTION
  ]
}; 